import {
  IconBuildingHospital,
  IconLayoutGrid,
  IconMapPin,
  IconUser,
  IconUsersGroup,
  IconUserShare,
  IconUserShield,
} from "@tabler/icons-react";

export const menuConfig = [
  {
    sideMenuTitle: "Dashboard",
    title: ["Dashboard"],
    path: "/dashboard",
    icon: <IconLayoutGrid stroke={1} />,
    roles: ["Admin", "Staff"],
  },
  {
    sideMenuTitle: "New Client Submissions",
    title: ["New Client Submission", "Manage Client Submission", "Submission Detail"],
    path: "/submission",
    icon: <IconUsersGroup stroke={1} />,
    roles: ["Admin", "Staff", "Marketer"],
  },
  {
    sideMenuTitle: "WellSky Clients",
    title: ["WellSky Clients", "WellSky Client Detail"],
    path: "/wellskyclients",
    icon: <IconBuildingHospital stroke={1} />,
    roles: ["Admin", "Staff", "Marketer"],
  },
  {
    sideMenuTitle: "Marketers",
    title: ["Marketer's Dashboard"],
    path: "/marketers",
    icon: <IconUserShare stroke={1} />,
    roles: ["Admin", "Staff", "Marketer"],
  },
  {
    sideMenuTitle: "Admin",
    title: ["Admin"],
    icon: <IconUserShield stroke={1} />,
    roles: ["Admin"],
    children: [
      {
        sideMenuTitle: "State - City",
        title: ["State - City"],
        path: "/state-city",
        icon: <IconMapPin stroke={1} />,
        roles: ["Admin"],
      },
      {
        sideMenuTitle: "Users",
        title: ["Users"],
        path: "/users",
        icon: <IconUser stroke={1} />,
        roles: ["Admin"],
      },
    ],
  },
];